import AvatarGroup from './avatar-group'

export type { AvatarGroupProps } from './avatar-group'

export default AvatarGroup
